import { gql } from '~/src/generated/portal/gql';

const GET_PROVIDER_IDS = gql(`
  query getProviderIds($partnerId: String!) {
    providers(partnerId: $partnerId) {
      id
      displayId
      partnerId
      countryCode
      created
    }
  }
`);
export default GET_PROVIDER_IDS;
